import { FormButtonLink } from 'src/components';
import { PATH_SIGN_IN } from 'src/routes';

import styles from '../../../../components/styles/RecoveryStage.module.scss';


type TProps = {
	email: string;
};

export function RecoveryStageEmailSuccess(props: TProps) {
	const { email } = props;

	return (
		<div className={ styles.recoveryPageStage }>
			<p className={ styles.paragraph }>
				На Электронный адрес «{ email }» было отправлено сообщение со ссылкой для восстановления пароля.
			</p>

			<FormButtonLink
				className={ styles.button }
				to={ PATH_SIGN_IN }
			>Готово</FormButtonLink>
		</div>
	);
}

